<div class="wrapper pointer" [ariaLabel]="ariaLabel()" (libAccessibleClick)="navigate()">
    <p class="body-1">{{ label() }}</p>
    <mat-icon class="small-icon" svgIcon="ico_caret_left"></mat-icon>
</div>
